import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { RecordingReview } from "@/components/teacher/RecordingReview";

export const RecordingsSection = ({ classId, onError }) => {
  const { t } = useLang();
  const tr = t.rec;
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("pending");

  const load = useCallback(() => {
    if (!classId) return;
    api.get(`/teacher/classes/${classId}/recordings`).then((r) => setItems(Array.isArray(r.data) ? r.data : [])).catch(onError);
  }, [classId]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [load]);

  const save = async (r, body) => {
    if (!body.rating) { toast.error(tr.tNeedRating); return; }
    try {
      const res = await api.put(`/teacher/recordings/${r.id}`, body);
      setItems((list) => list.map((x) => (x.id === r.id ? { ...x, ...res.data } : x)));
      toast.success(tr.tSaved);
    } catch (e) { onError(e); }
  };

  const pending = items.filter((x) => !x.reviewed_at);
  const shown = filter === "pending" ? pending : items;

  return (
    <section className="mt-12" data-testid="teacher-recordings-section">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-4">
        <h2 className="font-display text-3xl font-bold">{tr.tTitle}</h2>
        <div className="flex gap-2">
          {[["pending", `${tr.tPending} (${pending.length})`], ["all", `${tr.tAll} (${items.length})`]].map(([k, label]) => (
            <button key={k} onClick={() => setFilter(k)} data-testid={`teacher-recordings-filter-${k}`}
              className={`px-4 py-2 rounded-full text-sm border transition-colors ${filter === k ? "bg-[#1C1917] text-[#FAF7F2] border-[#1C1917]" : "border-[#E5DCCB] bg-white hover:border-[#1C1917]"}`}>{label}</button>
          ))}
        </div>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="teacher-recordings-grid">
        {shown.map((r) => <RecordingReview key={r.id} r={r} onSave={save} />)}
      </div>
      {!shown.length && <p className="p-6 text-center text-stone-600 bg-white border border-[#E5DCCB]" data-testid="teacher-no-recordings">{tr.tNone}</p>}
    </section>
  );
};
